import { StyleSheet } from 'react-native';
import { List } from '@banhala/ui-kit';
import type { PhotoReviewCarouselProps, PhotoReviewEntity } from './types';
import { PhotoReviewCard } from './components/PhotoReviewCard';
import { isNil } from '../../../../utils';

const VIEWABILITY_CONFIG = { itemVisiblePercentThreshold: 1 };

const keyExtractor = (_item: PhotoReviewEntity, index: number) =>
  index.toString();

const renderItem = ({ item }: { item: PhotoReviewEntity }) => (
  <PhotoReviewCard item={item.item} logging={item.logging} />
);

export const PhotoReviewCarousel = ({ entity }: PhotoReviewCarouselProps) => {
  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  return (
    <List<PhotoReviewEntity>
      horizontal
      data={entity}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={styles.scrollContent}
      viewabilityConfig={VIEWABILITY_CONFIG}
    />
  );
};

const styles = StyleSheet.create({
  scrollContent: {
    paddingHorizontal: 16,
    paddingBottom: 36,
    gap: 12,
  },
});
